import React from "react";

import styled from "styled-components";

const RequiredContainer = styled.div`
  // @media screen and (max-width: 767px) {
  //   .form-label,
  //   .text-danger {
  //     font-size: 13px;
  //     line-height: 12px;
  //   }
  // }
`;

const RequiredField = ({ children }) => (
  <RequiredContainer>
    {children}
    <span className="text-danger">*</span>
  </RequiredContainer>
);

export default RequiredField;
